
// export function camel (str) {
//   const camel = (str || '').replace(/-([^-])/g, g => g[1].toUpperCase());

//   return capitalize(camel);
// }

// export function camelActual (str) {
//   return (str || '').replace(/-(\w)/g, (_, c) => (c ? c.toUpperCase() : ''));
// }

// export function kebab (str) {
//   return (str || '').replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
// }

// export function capitalize (str) {
//   str = str || '';

//   return `${str.substr(0, 1).toUpperCase()}${str.slice(1)}`;
// }

// export function findProduct (store, id) {
//   return store.state.store.products.find(p => p.id === id);
// }

// export function isOnSale (variants) {
//   return variants.some(variant => {
//     return parseFloat(variant.price) < parseFloat(variant.compareAtPrice);
//   });
// }

// export function randomNumber (min, max) {
//   return Math.floor(Math.random() * max) + min;
// }

// export function randomString (length = 5) {
//   let text = '';
//   const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

//   for (let i = 0; i < length; i++) {
//     text += possible.charAt(Math.floor(Math.random() * possible.length));
//   }

//   return text;
// }
const randomElement = (arr = []) => {
  return arr[Math.floor(Math.random() * arr.length)];
};

const kebab = (str) => {
  return (str || '').replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
};

const toggleFullScreen = () => {
  let doc = window.document;
  let docEl = doc.documentElement;

  let requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
  let cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

  if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
    requestFullScreen.call(docEl);
  }
  else {
    cancelFullScreen.call(doc);
  }
};


const GENID = () => {
  return (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();
}


const thaiCharCutStr = (words, length) => {
  if (words == "")
    return ""

  if (length <= 0) {
    return words;
  }

  let count = 0;
  let cutIndex = 0;

  for (var index = 0; index < words.length; index++) {
    let charCode = words.charCodeAt(index);

    if (isThaiCharLength(charCode)) {
      count++;
    }   

    cutIndex = index + 1;
    if (count > length) {
      break;
    }
  }

  if (cutIndex > 0) {
    return words.substring(0, cutIndex);
  }
}

const isThaiCharLength = (charCode) => {

  if (charCode <= 3424 || charCode >= 3679)
    return true;

  // ก-อ
  if (charCode >= 3585 && charCode <= 3632) {
    return true
  }

  // อา อำ
  if (charCode >= 3634 && charCode <= 3635) {
    return true
  }

  // อิ 3636 อู 3641
  // ฿ เอ - ๆ
  if (charCode >= 3647 && charCode <= 3654) {
    return true
  }

  // อ็ 3655 -อ์ 3660
  // ๐ - ๙
  if (charCode >= 3664 && charCode <= 3673) {
    return true
  }

}

export default {
  randomElement,
  toggleFullScreen,
  kebab,
  GENID,
  thaiCharCutStr
};